import BigFloatButton from '../BigFloatButton/BigFloatButton';
import { useConfirmation } from '../../utils/ConfirmationServiceContext/confirmationContext';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks';
import { selectUserPermissions } from '../../containers/Login/LoginSlice';
import ChecklistItem from './ChecklistItem';
import styled from 'styled-components';
import { EmptyListFallback } from '../EmptyListFallback/EmptyListFallback';
import type { TabProps } from '../../containers/Checklists/Checklists.models';

const STemplateTab = styled.div`
  padding-bottom: 5rem;
`;

type TemplateProps = TabProps;

function Template({ checklists, onDotsClick, searchText }: TemplateProps) {
  const navigate = useNavigate();
  const confirm = useConfirmation();
  const userPermissions = useAppSelector(selectUserPermissions);
  const mayCreateTemplate = userPermissions?.checklists.mayCreateTemplate;

  const handleName = () => {
    confirm({
      description: 'checklist_name_checklist_template',
      onSubmit: (text?: string) => {
        if (text && text.length > 0) {
          navigate(`create/${encodeURIComponent(text)}`);
        }
      },
      onCancel: () => {},
      confirmText: 'proceed',
      inputBox: true,
      placeholderTx: 'checklist_name_template',
      isConfirmDisabledWhenEmpty: true,
    });
  };

  return (
    <STemplateTab role="templateChecklistsTab">
      {checklists.map(item => (
        <ChecklistItem
          checklist={item}
          key={`Template-${item.id}`}
          onDotsClick={onDotsClick}
          searchText={searchText}
        />
      ))}
      {checklists.length === 0 && (
        <EmptyListFallback
          listLength={checklists.length}
          isLoading={false}
          searchTerm={searchText}
          emptyListTx={'empty_checklists'}
          emptySearchTx={'messages_not_found_search'}
        />
      )}
      {mayCreateTemplate && (
        <BigFloatButton color="blue-outlined" tx={'checklist_new_template'} onClick={handleName} />
      )}
    </STemplateTab>
  );
}

export default Template;
